/**
 * Detects whether a value string is already in UTC ISO format (Z-suffixed),
 * e.g. "2026-04-04T15:59:00.000Z". Values emitted by .toISOString() always
 * match this shape. Naive HTML datetime-local strings (e.g. "2026-04-04T23:59")
 * do NOT match.
 */
export const isUtcIsoString = (value: unknown): boolean => {
  return typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(value)
}
